document.getElementById('get-company-postal-code').addEventListener("click", () => {
    setButtonLoading('get-company-postal-code');
    let postalCode = document.getElementById('company-postal-code').value;
    if (!postalCode || postalCode.length !== 7) {
        resetButton('get-company-postal-code');
        return false;
    }

    getPostalCode(postalCode, 'company-region', 'company-locality');
})

function getPostalCode(postalCode, regionId, LocalityId,) {
    let xhr = new XMLHttpRequest();
    xhr.open('GET', '/api/search/postal_code?postal_code=' + encodeURIComponent(postalCode), true)
    xhr.responseType = 'json'
    xhr.send()
    xhr.onload = function (e) {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                hideError();
                let result = xhr.response;
                document.getElementById(regionId).value = result.pref_code;
                document.getElementById(LocalityId).value = result.city_name + result.town_name;
            } else {
                showError(xhr.response.message);
            }
            resetButton('get-company-postal-code');
        }
    }
}

function setButtonLoading(buttonId) {
    const btn = document.getElementById(buttonId);
    btn.disabled = true;
    btn.textContent = '検索中...';
    btn.style.cursor = 'not-allowed';
}

function resetButton(buttonId) {
    const btn = document.getElementById(buttonId);
    btn.disabled = false;
    btn.textContent = '自動入力';
    btn.style.cursor = '';
}

function showError(message) {
    const errorElement = document.getElementById('company-postal-code-error');
    if (errorElement) {
        errorElement.textContent = message;
        errorElement.style.display = 'block';
        errorElement.classList.add('_error');
    }
}

function hideError() {
    const errorElement = document.getElementById('company-postal-code-error');
    if (errorElement) {
        errorElement.textContent = '';
        errorElement.style.display = 'none';
        errorElement.classList.remove('_error');
    }
}